export default {
    project_name: "Electrolux Academy"
}